import { createPropertyMarker } from './components/propertyMarker';

class MapPropertyMarkersView {
  constructor({ element, map }) {
    this.element = element;
    this.map = map;
    this._propertyGroups = [];
    this._markers = [];
    this._markerHandles = [];
  }

  /** PRIVATE METHODS **/

  handleMarkerMouseOver = e => {
    const marker = this.findMarkerFromEvent(e);
    this.dispatchMarkerEvent('marker:mouseover', marker);
  }

  handleMarkerMouseOut = e => {
    const marker = this.findMarkerFromEvent(e);
    this.dispatchMarkerEvent('marker:mouseout', marker);
  }

  handleMarkerClick = e => {
    const marker = this.findMarkerFromEvent(e);
    e.stopPropagation();
    e.preventDefault();
    this.dispatchMarkerEvent('marker:click', marker);
  }

  dispatchMarkerEvent(eventName, marker) {
    const propertyGroup = this.findPropertyFromMarker(marker);
    this.element.dispatchEvent(new CustomEvent(eventName, {
      detail: {
        propertyGroup,
        marker
      }
    }));
  }

  findPropertyFromMarker(marker) {
    const index = this._markers.indexOf(marker);
    return this._propertyGroups[index];
  }

  findMarkerFromDom(element) {
    const id = element.getAttribute('data-id');
    return this._markers.find(marker => marker.getId().toString() === id);
  }

  findMarkerFromEvent(event) {
    return this.findMarkerFromDom(event.target);
  }

  addMarkerEvents() {
    this._markers.forEach(marker => {
      this._markerHandles.push(window.google.maps.event.addListener(marker, 'mouseover', this.handleMarkerMouseOver));
      this._markerHandles.push(window.google.maps.event.addListener(marker, 'mouseout', this.handleMarkerMouseOut));
      this._markerHandles.push(window.google.maps.event.addListener(marker, 'click', this.handleMarkerClick));
    });
  }

  removeMarkerEvents() {
    this._markerHandles.forEach(markerHandle => {
      window.google.maps.event.removeListener(markerHandle);
    });
  }

  propertyGroupFromPropertyId(propertyId) {
    return this._propertyGroups.find(group => !!group.properties.find(property => property.id === propertyId));
  }

  markerFromPropertyId(propertyId) {
    const propertyGroup = this.propertyGroupFromPropertyId(propertyId);
    if (!propertyGroup) {
      return null;
    }
    const index = this._propertyGroups.indexOf(propertyGroup);
    return this._markers[index];
  }

  /** PUBLIC METHODS **/

  createMarkers(propertyGroups, markerType) {
    propertyGroups.sort((a, b) => a.label < b.label ? -1 : Number(a.label > b.label));

    this.removeMarkers();

    this._propertyGroups = propertyGroups;

    this._propertyGroups.forEach(propertyGroup => {
      const marker = createPropertyMarker({
        position: propertyGroup.location,
        label: propertyGroup.label,
        id: propertyGroup.id,
        map: this.map
      }, markerType);
      this._markers.push(marker);
    });
    this.addMarkerEvents();
  }

  removeMarkers() {
    this.removeMarkerEvents();
    this._markers.forEach(marker => {
      marker.setMap(null);
    });
    this._markers = [];
    this._propertyGroups = [];
  }

  highlightMarker(propertyId) {
    const marker = this.markerFromPropertyId(propertyId);
    if (marker) marker.addClass('highlight');
  }

  unHighlightMarker(propertyId) {
    const marker = this.markerFromPropertyId(propertyId);
    if (marker) marker.removeClass('highlight');
  }

  setCenterOnProperty(propertyId) {
    const propertyGroup = this.propertyGroupFromPropertyId(propertyId);
    if (propertyGroup) this._map.setCenter(propertyGroup.location);
  }

  on(event, callback) {
    this.element.addEventListener(event, callback);
  }

  off(event, callback) {
    this.element.removeEventListener(event, callback);
  }

  destroy() {
    this.removeMarkers();
    this.element = null;
    this.map = null;
    this._propertyGroups = null;
    this._markers = null;
    this._markerHandles = null;
  }
}

export default MapPropertyMarkersView;
